import React from 'react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const Input = React.forwardRef(({ className, ...props }, ref) => {
    return (
        <input
            ref={ref}
            className={twMerge(clsx(
                "w-full bg-[#0c0a09] border border-stone-700 text-white rounded px-3 py-2 text-sm focus:outline-none focus:border-blue-600 transition-colors placeholder:text-stone-600",
                className
            ))}
            {...props}
        />
    );
});

Input.displayName = 'Input';
